export default "__VITE_ASSET__e095a66c__"